import React from 'react';
import PropTypes from 'prop-types';

// import SmartSearch from 'SmartSearch';
import BaseAndTarget from '../components/QuickReports/BaseAndTarget';
import QuickReportsSelector from '../components/QuickReports/QuickReportsSelector';

const QuickReportsEditor = ({
  quickReportsStudy,
  getSampleWeighted,
  gridData,
}) => (
  <div>
    {/* <div className="smart-search-editor">
      <div className="appBreadcrumb"><p>
      <span className="parent">Insights / </span>Quick Reports</p></div>
      <div className="large-12">
        <SmartSearch
          selectedModule="quickReports"
          moduleStudy={quickReportsStudy}
          getSampleWeighted={getSampleWeighted}
          fetchKPI={fetchKPI}
          gridData={gridData}
        />
      </div>
      <h3 className="title margin-bottom-o">{
        quickReportsStudy ? quickReportsStudy.studyDescription : ''
      }</h3>
    </div> */}
    <div className="column quickreport-body">
      <BaseAndTarget
        quickReportsStudy={quickReportsStudy}
        getSampleWeighted={getSampleWeighted}
        gridData={gridData}
      />
      <QuickReportsSelector quickReportsStudy={quickReportsStudy} />
    </div>
  </div>
);

QuickReportsEditor.propTypes = {
  quickReportsStudy: PropTypes.shape({}),
  getSampleWeighted: PropTypes.func,
  gridData: PropTypes.shape({}),
};

export default QuickReportsEditor;
